import styled from 'styled-components';

export const Container = styled.div`
  display: grid;
  grid-template-columns: 390px 1fr;
  grid-gap: 10px;
  margin: 0.5rem 0.5rem 0.5rem 1rem;
`;
